import { WIDGET_URL } from "../../../config";

const ReactCode = ({ botScriptURL }) => (
  <pre>
    <span className="c-kw">import</span> {"{"}{" "}
    <span className="c-var">useEffect</span> {"}"}{" "}
    <span className="c-kw">from</span> <span className="c-str">'react'</span>;
    {"\n\n"}
    <span className="c-fn">useEffect</span>
    {"(() => {"}
    {"\n"}
    {"    "}
    <span className="c-cm">// Create and inject the Kelu AI widget script</span>
    {"\n"}
    {"    "}
    <span className="c-kw">const</span> <span className="c-var">script</span>{" "}
    {"= document."}
    <span className="c-fn">createElement</span>
    {"("}
    <span className="c-str">"script"</span>
    {")"};{"\n"}
    {"    "}
    <span className="c-var">script</span>.src {"="}
    {"\n"}
    {"      "}
    <span className="c-str">{`"${botScriptURL}"`}</span>;{"\n"}
    {"    "}
    <span className="c-var">script</span>.async {"= "}
    <span className="c-kw">true</span>;{"\n"}
    {"    "}
    <span className="c-var">document</span>.body.
    <span className="c-fn">appendChild</span>
    {"("}
    <span className="c-var">script</span>
    {")"};{"\n\n"}
    {"    "}
    <span className="c-cm">
      // Cleanup: destroy widget when component unmounts
    </span>
    {"\n"}
    {"    "}
    <span className="c-kw">return</span> {"() => {"}
    {"\n"}
    {"      "}
    <span className="c-cm">{"// @ts-ignore"}</span>
    {"\n"}
    {"      "}
    <span className="c-kw">if</span> {"(window?.KeluAiChatWidget)"}
    {"\n"}
    {"        "}window.<span className="c-var">KeluAiChatWidget</span>?.
    <span className="c-fn">destroy</span>
    {"()"};{"\n"}
    {"    };"}
    {"\n"}
    {"  "}
    {`}, []);`}
    {"\n\n"}
    {"  "}
  </pre>
);

export default ReactCode;
